import { render, staticRenderFns } from "./BottomNavbar.vue?vue&type=template&id=377bc7b8&scoped=true&"
import script from "./BottomNavbar.vue?vue&type=script&lang=js&"
export * from "./BottomNavbar.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavbar.vue?vue&type=style&index=0&id=377bc7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bc7b8",
  null
  
)

export default component.exports